import { render, staticRenderFns } from "./EventViewPromoCode.vue?vue&type=template&id=1000971a&"
import script from "./EventViewPromoCode.vue?vue&type=script&lang=js&"
export * from "./EventViewPromoCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports